/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import Alert from "../../components/Alert";
import BaseCom from "../../components/BaseCom";
import DataTable from "../../components/DataTable";
import LoadingAlert from "../../components/LoadingAlert";
import { withParamsAndNavigate } from "../../components/WithParamsAndNavigate";
import { qreq } from "../../shared/qrequest";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as fa from '@fortawesome/free-solid-svg-icons'
import { SidebarGlobal } from "../../components/Sidebar";

class Products extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            query: {},
            loaded: false,
            loading: false,
            list: [],
            tab: this.props.params.tab
        };
        this.load = this.load.bind(this);
    }

    componentDidMount() {
        SidebarGlobal.setSubNav(<><div className="btn-group">
            <Link to={'/product/new' + (this.props.params.tab === 'conservative-care' ? '/conservative-care' : '')} className="btn btn-primary"><FontAwesomeIcon icon={fa.faPlus} /> <span className="d-none d-md-inline">New Product</span></Link>
        </div></>);
        this.load(this.props.params.tab); 
        this.applyThemeColors();    
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    componentDidUpdate(prevProps) {
        if (this.props.params.tab !== prevProps.params.tab) {
            this.setState({ tab: this.props.params.tab });
            this.load(this.props.params.tab);
        }
    }

    load(tab) {
        SidebarGlobal.setSubNav(<><div className="btn-group">
            <Link to={'/product/new' + (tab === 'conservative-care' ? '/conservative-care' : '')} className="btn btn-primary"><FontAwesomeIcon icon={fa.faPlus} /> <span className="d-none d-md-inline">New Product</span></Link>
        </div></>);
        this.setState({ loading: true });
        qreq.post('/api/product/list' + (tab === 'conservative-care' ? '?isConservativeCare=true' : ''), this.state.query, j => {
            if (j.list) {
                this.setState({ list: j.list });
            }
            else if (j.errorCode !== 0) {
                this.setState({ errorMessage: j.errorMessage });
            }
            this.setState({ loaded: true, loading: false });
        }, () => {
            this.setState({ loaded: true, loading: false, errorMessage: 'Unknown error ocurred.' });
        });
    }

    render() {
        const header = (<h1>Products</h1>);

        if (!this.state.loaded)
            return (<div className="container-fluid">{header}<LoadingAlert /></div>);

        if (this.state.errorMessage)
            return <Alert type="danger" icon="ExclamationTriangle" message={this.state.errorMessage} />

        return <div className="container-fluid">
            {header}
            <DataTable columns={[
                { icon: 'Pencil', link: '/product/edit/:id', tooltip: 'Edit Product' },
                {
                    icon: 'Trash', tooltip: 'Remove Product', onClick: obj => {
                        if (window.confirm('Are you sure you want to delete \'' + obj.name + '\'?')) {
                            qreq.post('/api/product/delete', obj, j => {
                                if (j.errorCode === 0)
                                    this.load();
                                else
                                    this.alert(j.errorMessage);
                            });
                        }
                    }
                },
                { name: 'id', title: 'ID', link: '/product/edit/:id', tooltip: 'Edit Product', className: 'd-none d-md-table-cell' },
                { name: 'manufacturer', title: 'Manufacturer' },
                { name: 'productName', title: 'Product Name', link: '/product/edit/:id', tooltip: 'Edit Product' },
                { name: 'productSize', title: 'Size', className: 'd-none d-md-table-cell', valueFunc: row => {
                    if(row.units)
                        return <>{row.productSize} <span className="text-muted">{row.units}u</span></>;
                    return row.productSize;
                } },
                { name: 'catalogCode', title: 'Catalog Number' },
                { name: 'disabled', title: 'Disabled', format: 'bool', className: 'd-none d-md-table-cell' }
            ]} data={this.state.list} loading={this.state.loading} />
        </div>;
    }
}

export default withParamsAndNavigate(Products);